import axios from 'axios'

const request = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL_BACKEND,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor
request.interceptors.request.use(
  function (config) {
    config.headers.set('owner-url', window.location.host)
    return config
  },
  function (error) {
    return Promise.reject(error)
  },
)

// Response interceptor
request.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    return Promise.reject(error)
  },
)

export default request
